/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionSansSuiteDto
 */
export interface InscriptionSansSuiteDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionSansSuiteDto
     */
    idsinscription?: Array<number> | null;
    /**
     * 
     * @type {Date}
     * @memberof InscriptionSansSuiteDto
     */
    dateSansSuite?: Date;
}

/**
 * Check if a given object implements the InscriptionSansSuiteDto interface.
 */
export function instanceOfInscriptionSansSuiteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionSansSuiteDtoFromJSON(json: any): InscriptionSansSuiteDto {
    return InscriptionSansSuiteDtoFromJSONTyped(json, false);
}

export function InscriptionSansSuiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionSansSuiteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsinscription': !exists(json, 'idsinscription') ? undefined : json['idsinscription'],
        'dateSansSuite': !exists(json, 'dateSansSuite') ? undefined : (new Date(json['dateSansSuite'])),
    };
}

export function InscriptionSansSuiteDtoToJSON(value?: InscriptionSansSuiteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsinscription': value.idsinscription,
        'dateSansSuite': value.dateSansSuite === undefined ? undefined : (value.dateSansSuite.toISOString()),
    };
}

